import {
  Box,
  Button,
  HStack,
  IconProps,
  Text,
  UseRadioGroupReturn,
  useRadio,
  useRadioGroup
} from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Pathicon from "../../pathicon/Pathicon"

function HomeAugmentationRadio(
  props: ReturnType<UseRadioGroupReturn["getRadioProps"]>
) {
  const { getInputProps, getRadioProps } = useRadio(props)

  const input = getInputProps()
  const checkbox = getRadioProps()

  return (
    <Box as="label">
      <input {...input} />
      <Button
        as={Box}
        {...checkbox}
        cursor="pointer"
        borderRadius="20px"
        variant={input.checked ? "solid" : "ghost"}
        p={2}
        size="xs"
        colorScheme="blackAlpha"
        color={input.checked ? "whiteAlpha.800" : undefined}
      >
        {props.children}
      </Button>
    </Box>
  )
}

export type HomeAugmentationFilter = {
  key: string
  icon: IconName
  iconProps?: IconProps
  label: string
}

type HomeAugmentationFiltersProps = {
  value: HomeAugmentationFilter["key"]
  onChange: (key: HomeAugmentationFilter["key"]) => void
  filters: HomeAugmentationFilter[]
}

function HomeAugmentationFilters({
  value,
  onChange,
  filters
}: HomeAugmentationFiltersProps) {
  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "HomeAugmentationFilters",
    value,
    onChange
  })

  return (
    <HStack {...getRootProps()} w="100%" justifyContent="flex-start">
      {filters.map((option) => (
        <HomeAugmentationRadio
          key={option.key}
          {...getRadioProps({ value: option.key })}
        >
          <HStack>
            <Pathicon icon={option.icon} size="1em" {...option.iconProps} />
            <Text as="span" color="inherit">
              {option.label}
            </Text>
          </HStack>
        </HomeAugmentationRadio>
      ))}
    </HStack>
  )
}

export default HomeAugmentationFilters
